export const select = (record, user) => Boolean(user) && user.profile === 'Worker_c';
export const insert = (record, user) => Boolean(user) && false;
export const update = (record, user) => Boolean(user) && user.profile === 'Worker_c';
export const remove = (record, user) => Boolean(user) && false;
